export default {
  Detail: {
    StatisticCode: 'Mã thống kê',
    StatisticName: 'Tên mã thống kê',
    Description: 'Diễn giải',
    ActiveCheckbox: 'Theo dõi',
  },
};
